import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";

const CreatePage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/guide";

  // State untuk menyimpan form data. Jika initialData tersedia, isi form untuk update
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    note: "",
  });

  const isUpdateMode = !!initialData; // Cek apakah ini update mode atau create mode

  // API hook untuk create dan update
  const { createData: createGuide } = useCreateData(
    API_URL,
    "guides"
  );
  const { updateData: updateGuide } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "guides"
  );

  // Gunakan hook untuk menangani perubahan form
  const handleChange = useFormChangeHandler(setFormData);

  // Gunakan hook untuk menangani pengiriman form
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateGuide : createGuide,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  useEffect(() => {
    // Jika data produk berubah (untuk update), isi ulang form data
    if (initialData) {
      setFormData({
        ...initialData,
      });
    }
  }, [initialData]);

  return (
    <form
      onSubmit={(e) => handleBeforeSubmit(e)}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/* Guide Name */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="name"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Guide Name:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.name && "is-invalid"
              )}
              id="name"
              placeholder="Guide Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              required
              minLength={3}
            />
            {formError?.name && (
              <div className="invalid-feedback">{formError.name}</div>
            )}
          </div>
        </div>

        {/* Email */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="email"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Email:
          </label>
          <div className="col-sm-8">
            <input
              type="email"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.email && "is-invalid"
              )}
              id="email"
              placeholder="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.email && (
              <div className="invalid-feedback">{formError.email}</div>
            )}
          </div>
        </div>

        {/* Phone */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="phone"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Phone:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.phone && "is-invalid"
              )}
              id="phone"
              placeholder="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.phone && (
              <div className="invalid-feedback">{formError.phone}</div>
            )}
          </div>
        </div>

        {/* Note */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="note"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Note:
          </label>
          <div className="col-sm-8">
            <textarea
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.note && "is-invalid"
              )}
              id="note"
              placeholder="Note"
              name="note"
              value={formData.note}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "70px" }}
            />
            {formError?.note && (
              <div className="invalid-feedback">{formError.note}</div>
            )}
          </div>
        </div>

        {/* Submit Button */}
        <div className="form-group mt-auto d-grid">
          <button
            type="submit"
            className="btn btn-primary btn-block"
            disabled={isSubmitting}
          >
            {isUpdateMode ? "Update Guide" : "Create Guide"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreatePage;
